module.exports = __webpack_public_path__ + "static/media/lun.45bc0616.svg";